module.exports = __webpack_public_path__ + "static/media/view investigation exclusions.efbd96a6.svg";